export function formatNumber(value: number | undefined | null) {
  return new Intl.NumberFormat("zh-CN").format(Number(value || 0));
}

export function formatPercent(value: number | undefined | null) {
  return `${Number(value || 0).toFixed(2).replace(/\.00$/, "")}%`;
}

export function formatDateTime(value: string | null | undefined) {
  if (!value) return "—";
  const normalized = value.includes("T") ? value : `${value.replace(" ", "T")}Z`;
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString("zh-CN", { hour12: false });
}

export function formatDuration(seconds: number | undefined | null) {
  const total = Math.max(0, Number(seconds || 0));
  if (total < 60) return `${Math.round(total)} 秒`;
  if (total < 3600) return `${(total / 60).toFixed(1)} 分钟`;
  return `${(total / 3600).toFixed(1)} 小时`;
}

export function formatLatency(milliseconds: number | undefined | null) {
  const value = Math.max(0, Number(milliseconds || 0));
  if (value < 1000) return `${Math.round(value)} ms`;
  return `${(value / 1000).toFixed(value < 10000 ? 2 : 1)} 秒`;
}
